import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Partner {
  name: string;
  logo: string;
  website?: string;
}

@Component({
  selector: 'app-partners',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
})
export class PartnersComponent {
  partners: Partner[] = [
    {
      name: 'National Health Authority',
      logo: '/NHA/partners/nha.png',
      website: 'https://nha.gov.in/',
    },
    {
      name: 'Ministry of Health and Family Welfare',
      logo: '/NHA/partners/Ministry_of_health_and_family_welfare.png',
      website: 'https://www.mohfw.gov.in/',
    },
    {
      name: 'Digital India',
      logo: '/NHA/partners/Digital_India_logo.png',
      website: 'https://www.digitalindia.gov.in/',
    },
    {
      name: 'Ministry of Electronics & Information Technology',
      logo: '/NHA/partners/ministry_of_electonics.png',
      website: 'https://www.meity.gov.in/',
    },
    {
      name: 'Open Government Data (India)',
      logo: '/NHA/partners/data_gov.png',
      website: 'https://www.data.gov.in/',
    },
  ];
}

